import gql from 'graphql-tag';
import { kmsClient } from 'api';
import { useMutation } from '@apollo/react-hooks';
import { UpdateArticleMutation, UpdateArticleMutationVariables } from './__generated__/UpdateArticleMutation';

const UPDATE_ARTICLE_MUTATION = gql`
  mutation UpdateArticleMutation($articleInput: UpdateArticleInput!) {
    updateArticle(articleInput: $articleInput) {
      article {
        id
      }
      errors
    }
  }
`;

export const useUpdateArticleMutation = () => {
  return useMutation<UpdateArticleMutation, UpdateArticleMutationVariables>(UPDATE_ARTICLE_MUTATION, {
    client: kmsClient
  });
};
